import React from "react";
import { ProductCard, CustomCard, CatBrandSkeleton, ProductSkeleton } from "@/components";
import { GridItem } from "@/types/AppTypes";
import { CustomGridProps } from "@/types/AppTypes";
import { cn } from "@/lib/utils";

const CustomGrid: React.FC<CustomGridProps> = React.memo(
  ({
    gridItems = [],
    isProduct = false,
    className = "",
    GridItemClassName = "",
    bgGradients = [],
    sectionHeader = null,
    cardLink = "",
    onAddToCart = () => {},
    loading = false,
    skeletonCount = 8,
    isCategory = false,
  }) => {
    return (
      <section className={`py-8 px-1  md:px-1`}>
        <div className="container mx-auto px-0 max-w-6xl">
          {sectionHeader}
          {!loading ? (
            <div
              className={cn(
                "grid  grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-6 ",
                className
              )}
            >
              {gridItems?.map((item: GridItem, index: number) =>
                !isProduct ? (
                  <CustomCard
                    key={index}
                    name={item?.name}
                    //description={item?.productCount}
                    icon={item?.icon}
                    image={item?.image}
                    className={GridItemClassName}
                    gradient={bgGradients[index % bgGradients.length]}
                    cardLink={cardLink}
                    item={item}
                    isCategory={isCategory}
                  />
                ) : (
                  <ProductCard
                    key={item?.id}
                    className={GridItemClassName}
                    product={item}
                    onAddToCart={onAddToCart}
                  />
                )
              )}
            </div>
          ) : !isProduct ? (
            <CatBrandSkeleton count={skeletonCount} />
          ) : (
            <ProductSkeleton count={skeletonCount} />
          )}
        </div>
      </section>
    );
  }
);

export default CustomGrid;
